"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApproximateDailyImpressions = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
function normalizeExplicitLegacyAudienceValue(value) {
    if (value === null || value === undefined || (typeof value === "string" && value.trim() === "")) {
        return undefined;
    }
    if (typeof value !== "number" && typeof value !== "string") {
        return value;
    }
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : value;
}
/** @deprecated Use audience_stats daily totals. */
class ApproximateDailyImpressions {
    /** @deprecated Use audience_stats daily totals. */
    min;
    /** @deprecated Use audience_stats daily totals. */
    max;
    /** @deprecated Use audience_stats daily totals. */
    average;
}
exports.ApproximateDailyImpressions = ApproximateDailyImpressions;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => normalizeExplicitLegacyAudienceValue(value))
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", Number)
], ApproximateDailyImpressions.prototype, "min", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => normalizeExplicitLegacyAudienceValue(value))
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", Number)
], ApproximateDailyImpressions.prototype, "max", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Transform)(({ value }) => normalizeExplicitLegacyAudienceValue(value))
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", Number)
], ApproximateDailyImpressions.prototype, "average", void 0);
